import { GoalKeeper } from "./pegs/GoalKeeper";
import { PlayersManager } from "./players/PlayersManager";
import { MovingPlatformsManager } from "./pegs/MovingPlatformsManager";
import { StreakerManager } from "./StreakerManager";
import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { CactusPeg } from "./pegs/CactusPeg";
import { Mushroom } from "./pegs/Mushroom";
import { SolidPeg } from "./pegs/SolidPeg";
import { ElasticPeg } from "./pegs/ElasticPeg";
import { MidfielderPlayer } from "./players/MidfielderPlayer";
import { Player } from "./players/Player";
import { ForwardPlayer } from "./players/ForwardPlayer";
import { SolidPlank } from "./pegs/SolidPlank";
import { Plank } from "./pegs/Plank";
import { CactusPlank } from "./pegs/CactusPlank";
import { Blade } from "./pegs/Blade";
import { ExtraBall } from "./pegs/ExtraBall";
import { MovingPlatform } from "./pegs/MovingPlatform";
import { MagicPotion } from "./pegs/MagicPotion";

export class PegsContainer extends Phaser.Group {

    public goalKeeper: GoalKeeper;
    public playersManager: PlayersManager;
    public movingPlatformsManager: MovingPlatformsManager;
    public streakerManager: StreakerManager;

    // para poder ordenarlos en Z pero poniendo los elementos moviles por encima
    private staticItemsArray: any[];
    private mobileItemsArray: any[];
    private updateFunction: Function;

    private blinkingItemsArray: any[];
    private blinkingItemsNumber: number;
    private b: number;
    private blinkingItemIndex: number;
    private blinkingFrameSteps: number[]; // un array donde se guardan los pasos donde pestañea un item
    // para que sea variable el numero de frames que deben pasar para
    // que alguien pestañee
    constructor(game: Phaser.Game) {

        super(game, null, "pegs container", false);

        let levelData: any = GameVars.getLevelData(GameVars.matchID - 1);

        this.playersManager = null;
        this.movingPlatformsManager = null;
        this.streakerManager = null;

        this.staticItemsArray = [];
        this.mobileItemsArray = [];
        this.blinkingItemsArray = [];

        let item: any;
        let type: string;
        let px: number;
        let py: number;
        let rotation: number;

        for (let i = 1; i < levelData.length; i++) {

            type = levelData[i].t;
            px = levelData[i].x;
            py = levelData[i].y;
            rotation = levelData[i].r * Math.PI / 180;

            if (type === GameConstants.CACTUS_PEG) {
                item = new CactusPeg(this.game, px, py);
            } else if (type === GameConstants.PEG_1) {
                item = new Mushroom(this.game, px, py, 1);
            } else if (type === GameConstants.PEG_2) {
                item = new Mushroom(this.game, px, py, 2);
            } else if (type === GameConstants.PEG_3) {
                item = new Mushroom(this.game, px, py, 3);
            } else if (type === GameConstants.PEG_4) {
                item = new Mushroom(this.game, px, py, 4);
            } else if (type === GameConstants.SOLID_PEG) {
                item = new SolidPeg(this.game, px, py);
            } else if (type === GameConstants.ELASTIC_PEG_RIGHT) {

                item = new ElasticPeg(this.game, px, py, true);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.ELASTIC_PEG_LEFT) {

                item = new ElasticPeg(this.game, px, py, false);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.SOLID_PEG) {
                item = new SolidPeg(this.game, px, py);
            } else if (type === GameConstants.MIDFIELDER_PEG_LEFT) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new MidfielderPlayer(this.game, px, py, false, this.playersManager, Player.STILL);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.MIDFIELDER_PEG_RIGHT) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new MidfielderPlayer(this.game, px, py, true, this.playersManager, Player.STILL);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.MIDFIELDER_PEG_RIGHT_MOVING_VERTICALLY_1) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new MidfielderPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_VERTICALLY_1);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.MIDFIELDER_PEG_RIGHT_MOVING_HORIZONTALLY_1) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new MidfielderPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_HORIZONTALLY_1);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.MIDFIELDER_PEG_RIGHT_MOVING_VERTICALLY_2) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new MidfielderPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_VERTICALLY_2);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.MIDFIELDER_PEG_RIGHT_MOVING_HORIZONTALLY_2) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new MidfielderPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_HORIZONTALLY_2);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.FORWARD_PEG_LEFT) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new ForwardPlayer(this.game, px, py, false, this.playersManager, Player.STILL);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.FORWARD_PEG_RIGHT) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new ForwardPlayer(this.game, px, py, true, this.playersManager, Player.STILL);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.FORWARD_PEG_RIGHT_MOVING_VERTICALLY_1) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new ForwardPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_VERTICALLY_1);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.FORWARD_PEG_RIGHT_MOVING_HORIZONTALLY_1) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new ForwardPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_HORIZONTALLY_1);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.FORWARD_PEG_RIGHT_MOVING_VERTICALLY_2) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new ForwardPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_VERTICALLY_2);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.FORWARD_PEG_RIGHT_MOVING_HORIZONTALLY_2) {

                if (this.playersManager == null) {
                    this.playersManager = new PlayersManager(this.game);
                }

                item = new ForwardPlayer(this.game, px, py, true, this.playersManager, Player.MOVING_HORIZONTALLY_2);
                this.playersManager.addPlayer(item);
                this.blinkingItemsArray.push(item);

            } else if (type === GameConstants.SOLID_PLANK) {
                item = new SolidPlank(this.game, px, py, rotation);
            } else if (type === GameConstants.BREAKABLE_PLANK_1) {
                item = new Plank(this.game, px, py, rotation, 1);
            } else if (type === GameConstants.BREAKABLE_PLANK_2) {
                item = new Plank(this.game, px, py, rotation, 2);
            } else if (type === GameConstants.BREAKABLE_PLANK_3) {
                item = new Plank(this.game, px, py, rotation, 3);
            } else if (type === GameConstants.BREAKABLE_PLANK_4) {
                item = new Plank(this.game, px, py, rotation, 4);
            } else if (type === GameConstants.CACTUS_PLANK) {
                item = new CactusPlank(this.game, px, py, rotation);
            } else if (type === GameConstants.BLADE_CW) {
                item = new Blade(this.game, px, py, rotation, true);
            } else if (type === GameConstants.BLADE_CCW) {
                item = new Blade(this.game, px, py, rotation, false);
            } else if (type === GameConstants.EXTRA_BALL) {
                item = new ExtraBall(this.game, px, py);
            } else if (type === GameConstants.MOVING_PLATFORM_RIGHT) {

                if (this.movingPlatformsManager == null) {
                    this.movingPlatformsManager = new MovingPlatformsManager(this.game);
                }

                item = new MovingPlatform(this.game, px, py, true, rotation);
                this.movingPlatformsManager.addPlatform(item);

            } else if (type === GameConstants.MOVING_PLATFORM_LEFT) {

                if (this.movingPlatformsManager == null) {
                    this.movingPlatformsManager = new MovingPlatformsManager(this.game);
                }

                item = new MovingPlatform(this.game, px, py, false, rotation);
                this.movingPlatformsManager.addPlatform(item);
            } else if (type === GameConstants.MAGIC_POTION) {
                item = new MagicPotion(this.game, px, py);
            }

            if (type === GameConstants.MOVING_PLATFORM_LEFT
                || type === GameConstants.MOVING_PLATFORM_RIGHT
                || type === GameConstants.BLADE_CW
                || type === GameConstants.BLADE_CCW) {
                this.mobileItemsArray.push(item);
            } else {
                this.staticItemsArray.push(item);
            }
        }

        this.staticItemsArray.sort(function (a, b): number { return a.y - b.y; });

        // para que los elementos moviles queden por encima delr esto de los elementos
        for (let i: number = 0; i < this.staticItemsArray.length; i++) {
            this.add(this.staticItemsArray[i]);
        }

        this.staticItemsArray.length = 0;

        this.mobileItemsArray.sort(function (a, b) { return a.y - b.y; });

        for (let i = 0; i < this.mobileItemsArray.length; i++) {
            this.add(this.mobileItemsArray[i]);
        }

        this.mobileItemsArray.length = 0;

        if (this.playersManager !== null) {
            this.playersManager.init();
        }

        if (this.movingPlatformsManager !== null) {
            this.movingPlatformsManager.init();
        }

        this.addGoalKeeper();
        this.setUpStreakerManager();
        this.setUpdateLoop();
        this.setUpBlinkingSystem();
    }

    public update(): void {

        super.update();

        this.updateFunction();

        // los parpadeos
        this.b++;

        if (this.b > this.blinkingFrameSteps[this.blinkingItemIndex]) {
            this.b = 0;
            this.blinkingItemsArray[this.blinkingItemIndex].blink();
            this.blinkingItemIndex++;
            if (this.blinkingItemIndex > this.blinkingItemsNumber - 1) {
                this.blinkingItemIndex = 0;
            }
        }
    }

    public onVoodoo(): void {

        let i = this.children.length;

        while (i--) {
            var item: any = this.getChildAt(i);

            if (item.canBeAffectedByVoodoo) {
                item.makeVoodoo();
            }
        }
    }

    public onGamePaused(): void {

        if (this.playersManager !== null) {
            this.playersManager.onGamePaused();
        }
    }

    public onGameResumed(): void {

        if (this.playersManager !== null) {
            this.playersManager.onGameResumed();
        }
    }

    public onBallsManagerReadyToKickOff(): void {

        if (this.streakerManager !== null) {
            this.streakerManager.onKickOffManagerReadyToShoot();
        }
    }

    private addGoalKeeper(): void {

        this.goalKeeper = new GoalKeeper(this.game, 200, 850);
        this.add(this.goalKeeper);

        this.blinkingItemsArray.push(this.goalKeeper);
    }

    private setUpStreakerManager(): void {

        // si hay streaker
        if (GameVars.streakerFrequency > 0) {
            this.streakerManager = new StreakerManager(this.game, this);
        }
    }

    private setUpdateLoop(): void {

        // definir la funcion que se llama en el bucle update
        if (this.movingPlatformsManager !== null) {

            this.updateFunction = function (): void {
                this.movingPlatformsManager.update();
            };
        }

        // mirar si el playersManager contiene jugadores moviles
        if (this.playersManager !== null) {

            this.updateFunction = function (): void {
                this.playersManager.update();
            };
        }

        if (this.movingPlatformsManager !== null && this.playersManager !== null) {

            this.updateFunction = function (): void {
                this.movingPlatformsManager.update();
                this.playersManager.update();
            };
        }

        if (this.movingPlatformsManager === null && this.playersManager === null) {
            this.updateFunction = function (): void {
                //
            };
        }
    }

    private setUpBlinkingSystem(): void {

        this.blinkingFrameSteps = [];

        this.b = 0;
        this.blinkingItemIndex = 0;

        // concatenamos 2 veces el array a si mismo para tener un array 4 veces mayor aunque repetido
        // se reordena con un shuffle
        this.blinkingItemsArray = this.blinkingItemsArray.concat(this.blinkingItemsArray);
        this.blinkingItemsArray = this.blinkingItemsArray.concat(this.blinkingItemsArray);

        Phaser.ArrayUtils.shuffle(this.blinkingItemsArray);

        this.blinkingItemsNumber = this.blinkingItemsArray.length;

        // el array que contiene los intervalos de pestañeo
        const randomDataGenerator = new Phaser.RandomDataGenerator([1, 2, 3, 4, 5]);

        var blinkMinStep: number; // hacerlo dependiente de la cantidad de elementos que hayan
        var blinkMaxStep: number; // cuando solo hay 1 queda raro

        if (this.blinkingItemsNumber === 1) {
            // solo el portero
            blinkMinStep = 40;
            blinkMaxStep = 120;
        } else if (this.blinkingItemsNumber < 3) {
            blinkMinStep = 35;
            blinkMaxStep = 90;
        } else if (this.blinkingItemsNumber < 6) {
            blinkMinStep = 20;
            blinkMaxStep = 50;
        } else {
            blinkMinStep = 15;
            blinkMaxStep = 35;
        }

        for (let i = 0; i < this.blinkingItemsNumber; i++) {
            this.blinkingFrameSteps.push(randomDataGenerator.between(blinkMinStep, blinkMaxStep));
        }
    }
}
